import { BrowserRouter } from 'react-router-dom';
import RouterX from './router-x';
import { ThemeProvider } from '@material-tailwind/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools'; // Optional but recommended for development
import { AuthProvider } from './services/contexts/authContext';
import { LogErrorProvider } from './services/contexts/logErrorContext';
import { ErrorReportDialog } from './components/error-report-dialog';
import { Slide, ToastContainer } from 'react-toastify';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 1000 * 60 * 5,
    },
  },
});

const customTheme = {
  dialog: {
    styles: {
      base: {
        backdrop: {
          backgroundOpacity: 'bg-opacity-80',
          backdropFilter: '',
        },
      },
    },
  },
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider value={customTheme}>
          <AuthProvider>
            <LogErrorProvider>
              <RouterX />
              <ErrorReportDialog />
              <ToastContainer
                position="bottom-left"
                style={{ zIndex: 999999 }}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Slide}
              />
            </LogErrorProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default App;
